import axiosInstance from './axiosInstance';
import endpoints from './endpoints';

// Servicio para registrar contacto
export const registrarContacto = async (correoElectronico, empresa) => {
  try {
    // Validaciones básicas
    if (!correoElectronico || !empresa) {
      throw new Error('Por favor complete todos los campos');
    }

    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!emailRegex.test(correoElectronico)) {
      throw new Error('Por favor ingrese un correo electrónico válido');
    }

    if (empresa.trim().length < 3) {
      throw new Error('El nombre de la empresa debe tener al menos 3 caracteres');
    }

    // Realizar petición al backend
    const response = await axiosInstance.post(
      endpoints.calculator.registrarContacto,
      {
        correo_electronico: correoElectronico.trim(),
        empresa: empresa.trim()
      }
    );

    return {
      success: true,
      message: 'Contacto registrado exitosamente',
      data: response.data
    };

  } catch (error) {
    // Manejo de errores
    if (error.response) {
      const { status, data } = error.response;
      
      if (status === 400) {
        return {
          success: false,
          message: data.message || 'Los datos ingresados no son válidos. Verifique la información.'
        };
      } else if (status === 429) {
        return {
          success: false,
          message: 'Demasiadas solicitudes. Por favor, espere unos minutos e intente nuevamente.'
        };
      } else if (status >= 500) {
        return {
          success: false,
          message: 'Error interno del servidor. Intente nuevamente en unos momentos.'
        };
      }
      
      return {
        success: false,
        message: data.message || 'Error al registrar el contacto'
      };
      
    } else if (error.request) {
      return {
        success: false,
        message: 'Error de conexión. Verifique su conexión a internet e intente nuevamente.'
      };
    } else {
      return {
        success: false,
        message: error.message || 'Error al procesar la solicitud'
      };
    }
  }
};

const contactService = {
  registrarContacto
};

export default contactService;